export enum CustomEvents {
  VIEW_SEARCH_RESULTS = "view_search_results",
  BROCHURE_REQUEST_SUBMIT = "brochureRequest_formsubmit",
  CREATE_CASH_ACCOUNT_SUBMIT = "createCashAccount_formsubmit",
  CREATE_CREDIT_ACCOUNT_SUBMIT = "applyForCreditAccount_formsubmit",
  KITCHEN_ENQUIRY_SUBMIT = "kitchenEnquiry_formsubmit",
  BATHROOM_ENQUIRY_SUBMIT = "bathroomEnquiry_formsubmit",
  TOOL_HIRE_ENQUIRY_SUBMIT = "toolHireEnquiry_formSubmit",
  BRANCH_TELEPHONE_INTERACTION = "branchTelephoneNo_interaction",
  BRANCH_EMAIL_ADDRESS_INTERACTION = "branchEmailAddress_interaction",
  CATEGORY_PAGE_VIEW = "category_page_view",
  INVOICE_PAYMENT = "invoice_payment",
  STATEMENT_PAYMENT = "statement_payment",
  MONTHLY_STATEMENT_TRAY_OPEN = "monthly_statements_tray_opened",
  MONTHLY_STATEMENT_TRAY_CLOSE = "monthly_statements_tray_closed",
  QTY_CALC_OPEN = "qty_calculator_opened",
  QTY_CALC_CLOSED = "qty_calculator_closed",
  AREA_INPUT = "area_input_submitted",
  QTY_CALCULATED = "qty_calculated",
  LOGIN = "login",
}
